import React, { SFC, ReactNode } from 'react';

export const FormField: SFC<{ name: string; children: ReactNode }> = props => (
	<div className="margin-bottom">
		<h4 className="bold-font">{props.name}</h4>
		{props.children}
	</div>
);
